import { useState, useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { Form, Layout, Row, Col, Button, Typography, Select } from 'antd';

import { API } from '../../AxiosWrapper';
import BoxInfo from '../CreateDelivery/BoxInfo';
import { getSanitizedPhone } from '../shared/utils';
import { useFormatMessage, useHandleApiError } from '../shared/hooks'
import Email from '../shared/delivery/Email'
import Phone from '../shared/delivery/Phone'
import RentalCar from '../shared/delivery/RentalCar'
import InputField from '../shared/delivery/InputField'
import Boxes from '../CreateDelivery/Boxes'
import { UserContext, DataContext } from "../shared/context"

const { Item } = Form
const { Title } = Typography

const RegisterReturnDynamic = () => {
  const navigate = useNavigate()
  const [form] = Form.useForm();
  const handleApiError = useHandleApiError();
  const f = useFormatMessage();
  const { defaultBranchId: branchId } = useContext(UserContext)
  const { companyId, branches } = useContext(DataContext)

  const [posting, setPosting] = useState(false);
  const [lockers, setLockers] = useState(null);
  const [senders, setSenders] = useState([]);

  const getBoxSizes = (branchId) => {
    API.GET(`site/${branchId}/lockerTotals`)
      .then(response => setLockers(response.data))
      .catch(handleApiError)
  };

  const getSender = () => {
    API.GET('Sender/forCollection')
      .then(({ data }) => {
        if (!data) return
        setSenders(data);
        if (data.length === 1) form.setFieldValue('senderId', data[0].id)
      })
      .catch(handleApiError)
  };

  useEffect(() => {
    if (branchId === 0) return;
    getSender();
    getBoxSizes(branchId);
  }, [branchId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getBoxSize = (boxSize) => boxSize === 'none' ? null : boxSize;

  const handleSubmit = (values) => {
    setPosting(true);
    const newData = {
      deliveryBranchId: branchId,
      senderOrderId: values.senderOrderId,
      companyId: companyId,
      description: values.description || f("CreateDelivery.NoDescription"),
      senderId: values.senderId,
      recipient: {
        identificationNumber: values.kennitala?.replace(/\D/g, ''),
        name: values.recipientName,
        email: values.email ? values.email : null,
        phone: getSanitizedPhone(values.phone),
        street: values.street,
      },
      numberOfPackages: 1,
      createDate: values.createDate,
      deliveryMethod: "BOX",
      boxSize: getBoxSize(values.boxSize),
      rentalCar: values.rentalCar,
      paymentAmount: values.paymentAmount !== undefined && values.paymentAmount !== null && values.paymentAmount !== ''
        ? { value: parseInt(values.paymentAmount, 10) }
        : null,
      properties: {
        licensePlate: values.licensePlate ? values.licensePlate.toUpperCase() : null,
        arrivalTime: values.arrivalTime,
        departureTime: values.departureTime,
        parking: values.parking,
      },
    };

    API.POST('Delivery/collection', newData)
      .then(res => navigate(`/about-delivery/${res.data}`))
      .catch(handleApiError)
      .finally(() => setPosting(false));
  }

  if (branchId === 0) return "Branch is not selected."
  if (branches.length === 0) return "No branches"
  const siteName = branches.find(b => b.id === branchId)?.name

  return (
    <Layout.Content>
      <Title level={2} style={{ marginBottom: 16 }}><FormattedMessage id="CreateDelivery.CollectionTitle" /></Title>

      <Row>
        <Col xs={24} lg={12}>
          <Form
            layout="vertical"
            form={form}
            validateMessages={{
              required: f("Validation.Default.Required"),
              whitespace: f("CreateDelivery.FieldWhitespaceError"),
            }}
            className="form-style"
            preserve={true}
            onFinish={handleSubmit}
            initialValues={{
              boxSize: lockers && lockers[0]?.size,
            }}
          >
            <Item
              name="senderId"
              hidden={senders.length === 1}
              label={f('CreateCollection.ReceivingCompany')}
              hasFeedback
              rules={[{
                required: true, message: f("CreateDelivery.SenderRequired")
              }]}
            >
              <Select
                optionFilterProp="label"
                optionLabelProp="label"
                showSearch
                options={senders.map(s => ({ value: s.id, label: s.name }))}
              />
            </Item>
            <InputField name="kennitala" />
            <InputField name="recipientName" labelSelector="CreateCollection.Customer" />
            <InputField name="street" />
            <Email />
            <Phone />
            <hr />
            <InputField name="senderOrderId" />
            <InputField name="paymentAmount" />
            <InputField name="licensePlate" />
            <InputField name="arrivalTime" />
            <InputField name="departureTime" />
            <InputField name="description" />
            <InputField name="parking" />
            <RentalCar />

            <Boxes lockers={lockers} returningOld={false} />

            <Item>
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                loading={posting}
              >
                {f('CreateDelivery.Confirm')}
              </Button>
            </Item>
          </Form>
        </Col>

        <Col xs={24} lg={12}>
          <BoxInfo lockers={lockers} siteName={siteName} />
        </Col>
      </Row>
    </Layout.Content>
  );
}

export default RegisterReturnDynamic;
